import React from 'react';
import Carte from '../ui/Carte';
import ChampTexteLong from '../champs/ChampTexteLong';

function SectionProjet({ donnees, onChange }) {
  return (
    <Carte titre="Projet" icone="🎯">
      <div className="grille">
        <ChampTexteLong
          label="Contexte"
          valeur={donnees.contexte}
          onChange={onChange}
          nom="contexte"
          placeholder="Décrivez l'entreprise, son secteur d'activité et son contexte..."
          infobulle="Parler de l'entreprise, de son secteur et de son contexte. Description en 5-6 lignes en valorisant l'entreprise cliente."
          lignes={5}
        />
        <ChampTexteLong
          label="Problématique"
          valeur={donnees.problematique}
          onChange={onChange}
          nom="problematique"
          placeholder="Pourquoi l'entreprise fait-elle appel à la JE ? Comment a-t-elle connu la JE ?"
          infobulle="Expliquer pourquoi elle fait cette étude et comment elle connaît la JE. Doit contenir le plus de détails possible et être compréhensible par un non-initié."
          lignes={4}
        />
        <ChampTexteLong
          label="Définition du besoin"
          valeur={donnees.definitionBesoin}
          onChange={onChange}
          nom="definitionBesoin"
          placeholder="Décrire les envies du client et les objectifs de l'étude..."
          infobulle="Décrire l'envie du Client et les objectifs de l'étude."
          lignes={4}
        />

        <div style={{ borderTop: '1px solid var(--gris-bord)', paddingTop: 20, marginTop: 4 }}>
          <div style={{ fontSize: 13, fontWeight: 600, marginBottom: 12, color: 'var(--texte)' }}>
            Cahier des charges
          </div>
          <ChampTexteLong
            label="Critère de validation de l'étude"
            valeur={donnees.critereValidation}
            onChange={onChange}
            nom="critereValidation"
            placeholder="Décrire les conditions sous lesquelles le client considérera l'étude comme valide et terminée..."
            infobulle="Donner les conditions sous lesquelles le Client considérera l'étude comme valide et terminée. Soyez précis sur les livrables attendus : mentionnez le format (Word, PPT, site WordPress, etc.)."
            lignes={4}
          />
        </div>
      </div>
    </Carte>
  );
}

export default SectionProjet;
